module.exports = __webpack_public_path__ + "static/media/syncui_123.a63a10e8.ico";